import tw, { styled } from 'twin.macro'
import { Link } from 'gatsby'

const navbarSubLinkTemplate = tw`text-gray-600 no-underline block px-4 py-3 bg-white hover:text-white hover:bg-red-500 font-light`

const NavbarSubLink = styled(Link)`
  ${navbarSubLinkTemplate}
`

export const navbarSubLinkStyles = navbarSubLinkTemplate;

export default NavbarSubLink;
